<template lang="pug">
  MainPage(isShowLogout :title="$t('users')")
    v-row
      v-col.col-12
        AccountsTable
</template>

<script>

export default {
  name: 'Licenses',
  components: {
    AccountsTable: () => import('@/components/Blocks/Accounts/Table.vue'),
    MainPage: () => import('@/components/layout/MainPage.vue')
  }
}
</script>
